import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowLeft, ArrowRight, Button, Image } from '@outdoor-voices/ui';
import { memo, useCallback, useContext } from 'react';
import { Back } from './Back';
import { filterColorwaysForSwatches } from './utils';
import { KitContext } from './context';
import { ProductSelect } from './ProductSelect';
import ButtonsSwatches from '../../components/ButtonsSwatches';
import css from './Kit.module.scss';
import SelectAdvanced from '../../components/SelectAdvanced';
import SizeGuideOverlay from '../../components/SizeGuideOverlay';
import slugify from '../../utils/strings/slugify';
import updateArray from '../../utils/array/update';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Kit = /*#__PURE__*/memo(function () {
  var _useContext = useContext(KitContext),
      kit = _useContext.kit,
      state = _useContext.state,
      setState = _useContext.setState,
      step = _useContext.step,
      setStep = _useContext.setStep,
      totalSteps = _useContext.totalSteps;

  var stepState = state[step - 1];
  var sizeSelected = stepState.sizeSelected,
      colorwayId = stepState.colorwayId,
      productId = stepState.productId,
      options = stepState.options;
  var gender = kit.gender;
  var product = (options.find(function (_ref) {
    var product = _ref.product;
    return product.id === productId;
  }) || options[0]).product;
  var colorway = product.colorways.edges.find(function (_ref2) {
    var node = _ref2.node;
    return node.id === colorwayId;
  }).node;
  var color = colorway.color,
      variantStacks = colorway.variantStacks;
  var swatches = filterColorwaysForSwatches(product.colorways.edges);
  var sizes = variantStacks.map(function (vs) {
    return {
      label: vs.size,
      value: vs.size,
      disabled: !vs.variant.available
    };
  });
  var variant = sizeSelected ? variantStacks.find(function (_ref3) {
    var size = _ref3.size;
    return size === sizeSelected;
  }).variant : null;
  var assets = colorway.assets.edges.filter(function (_ref4) {
    var node = _ref4.node;
    return node.type !== 'KIT';
  });
  var onProductSelect = useCallback(function (newColorwayId, newProductId) {
    var newStepState = _objectSpread(_objectSpread({}, stepState), {}, {
      productId: newProductId,
      colorwayId: newColorwayId,
      variantId: null
    });

    setState(updateArray(state, step - 1, newStepState));
  }, [setState, state, step, stepState]);
  var onColorwaySelect = useCallback(function (newColorwayId) {
    var option = options.find(function (opt) {
      return opt.product.id === productId;
    });
    var newOptions = updateArray(options, options.indexOf(option), _objectSpread(_objectSpread({}, option), {}, {
      colorwayId: newColorwayId
    }));

    var newStepState = _objectSpread(_objectSpread({}, stepState), {}, {
      colorwayId: newColorwayId,
      options: newOptions
    });

    setState(updateArray(state, step - 1, newStepState));
    window.scrollTo({
      left: 0,
      top: 36
    });
  }, [options, productId, setState, state, step, stepState]);
  var onSizeSelect = useCallback(function (newSize) {
    var newStepState = _objectSpread(_objectSpread({}, stepState), {}, {
      sizeSelected: newSize
    });

    setState(updateArray(state, step - 1, newStepState));
  }, [setState, state, step, stepState]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Back, {}), /*#__PURE__*/_jsxs("div", {
      className: css.root,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.assets,
        children: assets.map(function (_ref5) {
          var node = _ref5.node;
          return /*#__PURE__*/_jsx("div", {
            className: css.asset,
            style: {
              aspectRatio: "".concat(node.image.width, " / ").concat(node.image.height)
            },
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, node.image), {}, {
              alt: "An image of ".concat(product.title, " in ").concat(colorway.color),
              sizes: [320, 436]
            }))
          }, node.id);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: css.sidebar,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.steps,
          children: ["Step ", step, " of ", totalSteps]
        }), /*#__PURE__*/_jsx(ProductSelect, {
          onProductSelect: onProductSelect,
          options: options,
          value: productId
        }), /*#__PURE__*/_jsxs("a", {
          className: css.title,
          href: product.absoluteUrl,
          rel: "noopener noreferrer",
          target: "_blank",
          children: [product.title, "\xA0", /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(ArrowRight, {})
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: css.description,
          dangerouslySetInnerHTML: {
            __html: product.pdp.subtitle
          }
        }), /*#__PURE__*/_jsxs("div", {
          className: css.label,
          children: ["Color: ", color]
        }), /*#__PURE__*/_jsx("div", {
          className: css.swatches,
          children: /*#__PURE__*/_jsx(ButtonsSwatches, {
            enableClickWhenDisabled: true,
            expand: true,
            label: "Select a color",
            onClick: onColorwaySelect,
            options: swatches,
            productTitle: product.title,
            value: colorway.id
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: css.sizeWrap,
          children: [/*#__PURE__*/_jsx("div", {
            className: css.label,
            children: "Size:"
          }), gender !== 'NONE' && /*#__PURE__*/_jsx(SizeGuideOverlay, {
            type: gender
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: css.sizes,
          children: /*#__PURE__*/_jsx(SelectAdvanced, {
            buttonProps: {
              bordered: true
            },
            compact: true,
            itemDisabledLabel: "Sold Out",
            label: "Select your size",
            id: "select-a-size-".concat(slugify(product.title)),
            onChange: onSizeSelect,
            options: sizes,
            value: sizeSelected || ''
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: css.actions,
          children: [step > 1 && /*#__PURE__*/_jsxs(Button, {
            big: true,
            full: true,
            bordered: true,
            onClick: function onClick() {
              setStep(step - 1);
            },
            children: [/*#__PURE__*/_jsx(ArrowLeft, {}), "Previous"]
          }), /*#__PURE__*/_jsxs(Button, {
            ariaLabel: step < totalSteps ? 'Navigate to the next step in configuring your kit' : 'Navigate to the confirmation screen of your kit',
            big: true,
            full: true,
            disabled: variant === null || !variant.available,
            onClick: function onClick() {
              setStep(step + 1);
            },
            children: ["Next", /*#__PURE__*/_jsx(ArrowRight, {})]
          })]
        })]
      })]
    })]
  });
});